module.exports = __webpack_public_path__ + "static/img/hzhb8.7cf0f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb8.png
// module id = J9E3
// module chunks = 0